export default __webpack_public_path__ + "static/media/bg-4.e93fa1c2.png";